import type { UpdateState } from './desktop'

/** Subscribe before reading the snapshot; a late snapshot must not overwrite a newer event. */
export function watchDesktopUpdate(shell: {
  version: string
  updateState?: () => Promise<UpdateState>
  onUpdateState?: (listener: (state: UpdateState) => void) => () => void
  onUpdateReady: (listener: (info: { version: string }) => void) => () => void
  onUpdateManual?: (listener: (info: { version: string; url: string }) => void) => () => void
}, listener: (state: UpdateState) => void): () => void {
  let active = true, changed = false
  let current: UpdateState = { status: 'idle', current: shell.version, latest: '', percent: 0, url: '', error: '', supported: true }
  const apply = (next: UpdateState) => { if (active) { changed = true; current = next; listener(next) } }
  const offState = shell.onUpdateState?.(apply)
  const offReady = shell.onUpdateReady(info => apply({ ...current, status: 'ready', latest: info.version }))
  const offManual = shell.onUpdateManual?.(info => apply({ ...current, status: 'manual', latest: info.version, url: info.url }))
  void shell.updateState?.().then(state => { if (active && !changed) { current = state; listener(state) } }).catch(() => undefined)
  return () => { active = false; offState?.(); offReady(); offManual?.() }
}
